import { useCallback, useEffect, useState } from 'react';
import { debounce } from 'lodash';

import { getTags } from '../api/services/Rides';
import * as Constants from '../constants';

interface UseTagsHook {
  tags: string[];
  debouncedQueryTags: (query: string) => void;
}

export const useTags = (): UseTagsHook => {
  const [tags, setTags] = useState<string[]>([]);

  const fetchTags = useCallback(async (query?: string) => {
    if (query?.length && query.length < Constants.MINIMUM_SEARCH_STRING_LENGTH) {
      return;
    }
    const response = await getTags({ q: query });

    if (response?.type === 'success') {
      const tagsData = response?.data;

      if (tagsData && tagsData.tags?.length > 0) {
        setTags(tagsData.tags);
      }
    }
  }, []);

  const debouncedQueryTags = debounce(fetchTags, 400);

  useEffect(() => {
    fetchTags();
  }, [fetchTags]);

  return { tags, debouncedQueryTags };
};
